import { useQuery } from '@tanstack/react-query';
import { ErrorResponse } from '../../types';
import billerHttp from './../../../utils/billerHttp';
import { BillerResponseData } from './types/biller.types';

export function useGeBillerProfileDetails() {
  const { data, isLoading, ...rest } = useQuery<BillerResponseData, ErrorResponse>({
    queryKey: ["get biller profile details"],
    queryFn: async () => {
      const response = await billerHttp.get(`billers/details`);
      return response.data;
    },
    staleTime: Infinity,
  });
  return {
    billerProfileData: data as BillerResponseData,
    isLoading,
    ...rest,
  }
}